import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_70lhdy7o: FaireBrandEntity = {
  token: "b_70lhdy7o",
  type: "brand",
  name: "The Good Twin",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/2edb9749a9b68af23b1ecc0e4e76c8a3442d995b08aab2305b81df3a2b0d4b99/1508178044.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e94171ccc3bf2f328755d285cebb31d5a00c2846b1162994cb339ce3f61d5ed.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/2edb9749a9b68af23b1ecc0e4e76c8a3442d995b08aab2305b81df3a2b0d4b99/1508178044.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e94171ccc3bf2f328755d285cebb31d5a00c2846b1162994cb339ce3f61d5ed.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 149,
  isTopShop: true,
  isInsider: true,
  description:
    "The Good Twin is owned and operated by Katie Wilson, in Los Angeles, California, with help from a small human team and her pug assistants, Stevie and Buffy (nappers-in-chief). In case you're wondering: yes, Katie is a twin. She likes to think she's the good one, but it really depends on the day. Her brother is older by 13 minutes, and they are at times eerily similar, but often complete opposites. \n\nAll illustration and type work is hand drawn with love, and our products are printed locally using high quality sustainable materials.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:02.722Z",
    importedBy: "entity-db-cli",
  },
};
